import React, { useState } from 'react'
import './customTable.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlassArrowRight } from '@fortawesome/free-solid-svg-icons';
import CustomSettingsSwitch from './CustomSettingsSwitch';

const SettingCustomTable = ({header, data, checkable=false, checkList=[], onCheck=null, onUncheckAll=null, onCheckAll=null,clickIcon=faMagnifyingGlassArrowRight,label="Elementi",noClick=false}) => {

    const [searchTerm, setSearchTerm] = useState("");

    const filteredData = data.filter((row) =>
        header.some(({ field }) =>
            row[field]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const areAllChecked = () => {
        return filteredData.every((verbal) => checkList.some((element) => element === verbal))
    }

  return (
    <div className='container-fluid custom-table'>
        <div className="mb-3 mt-2 row d-flex justify-content-between align-items-center">
            <div className='col-9'>
                <p className='m-0 ms-1'>{filteredData.length} {label} mostrati/e {`${checkable?`di cui ${checkList.length} selezionato/i`:""}`}</p>
            </div>
            <div className='col-3'>
                <input
                type="text"
                className="form-control"
                placeholder="Cerca..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
        </div>

        <div className="table-responsive br-8">
        <table className="table table-bordered table-hover br-8 text-center table-striped">
            <thead className="table-light sticky-top">
            <tr>
                {header.map(({ label }, index) => (
                <th key={index} scope="col">
                    {label}
                </th>
                ))}
                {!noClick && <th></th>}
                {checkable && <th onClick={(event)=>event.stopPropagation()}>
                    <input class="form-check-input checkbox-lg" type="checkbox" checked={areAllChecked()} id="flexCheckDefault" onChange={() => !areAllChecked() ? onCheckAll(filteredData) : onUncheckAll(filteredData)} onClick={(event) => event.stopPropagation()} />
                </th>}
            </tr>
            </thead>
            <tbody>
            {filteredData.length > 0 ? (
                filteredData.map((row, rowIndex) => (
                    <tr className='' key={rowIndex}>
                        {header.map(({ field }, colIndex) => (
                        typeof row[field] === "boolean"
                        ?<td className='' key={colIndex}><div className='d-flex justify-content-center'><div className='w-50'><CustomSettingsSwitch status={row[field]}/></div></div></td>
                        :<td key={colIndex}>{row[field] ?? ""}</td>
                        ))}
                        {!noClick &&<td><FontAwesomeIcon className='icon-custom-color fa-lg' icon={clickIcon} onClick={row.clickEvent}/></td>}
                        {checkable && <td onClick={(event)=>event.stopPropagation()}>
                            <input class="form-check-input checkbox-lg" type="checkbox" checked={checkList.some((element) => element === row)} id="flexCheckDefault" onChange={() => onCheck(row)}/>
                        </td>}
                    </tr>
                ))
            ) : (
                <tr>
                <td colSpan={header.length + (checkable ? 2 : 1)} className="text-center">
                    Nessun dato trovato.
                </td>
                </tr>
            )}
            </tbody>
        </table>
        </div>
    </div>
  );
}

export default SettingCustomTable